import {
  usePropertyCreate,
  usePropertyDelete,
  usePropertyGet,
  usePropertyGetSuspense,
  usePropertyList,
  usePropertyListSuspense,
  usePropertyPublicList,
  usePropertyUpdate,
} from "@/api/generated/endpoints/api"
import { propertyCreateBody, propertyUpdateBody } from "@/api/generated/schemas/api.zod"

export * as PropertyModels from "./models"

export const propertyApi = {
  // Query Hooks
  usePropertyList,
  usePropertyListSuspense,
  usePropertyPublicList,
  usePropertyGet,
  usePropertyGetSuspense,

  // Mutation Hooks
  usePropertyCreate,
  usePropertyUpdate,
  usePropertyDelete,
}

export const propertySchemas = {
  propertyCreateBody,
  propertyUpdateBody,
}
